import api from './api';
import { getUuidCandidate } from '@/utils/uuid';

export interface TipoProduto {
  id: string;
  codigo: string;
  descricao: string;
  ativo?: boolean;
  uuid?: string;
  erp_legacy_id?: number | string | null;
}

export function getTipoProdutoUuid(item: TipoProduto): string | null {
  return getUuidCandidate(item);
}

const tipoProdutoService = {
  async listar(filters: { ativo?: boolean; industrializacao?: boolean; is_industrializacao?: boolean } = {}): Promise<TipoProduto[]> {
    const response = await api.get<TipoProduto[]>('/industrializacao/tipo-produto', { params: filters });
    return response.data;
  },
};

export default tipoProdutoService;
